import { render, staticRenderFns } from "./TimeSlotReservation.vue?vue&type=template&id=638de032"
import script from "./TimeSlotReservation.vue?vue&type=script&lang=js"
export * from "./TimeSlotReservation.vue?vue&type=script&lang=js"
import style0 from "./css/timeSlotReservation.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports